export default "__VITE_ASSET__2a4b2882__"